var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3179",
    "data-name": "Rectangle 3179",
    width: 24,
    height: 24,
    fill: "#8a8a8a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "msgs",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2116",
    "data-name": "Path 2116",
    d: "M16.967,21.086a1.614,1.614,0,0,0-1.009-.259h-6.7a3.6,3.6,0,0,1-3.721-3.416V11.6h-.1a2.621,2.621,0,0,0-2.665,2.625v7.436A2.479,2.479,0,0,0,5.521,24h.94v2.769l3.064-2.6A1.223,1.223,0,0,1,10.287,24h5.181c1.327,0,2.735-.658,2.994-1.846Z",
    transform: "translate(-2.769 -2.769)",
    fill: "#8a8a8a",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2117",
    "data-name": "Path 2117",
    d: "M23.134,2.769H10.6a3.2,3.2,0,0,0-3.213,3.45v9.7A3.541,3.541,0,0,0,11,19.385h5.833a1.583,1.583,0,0,1,1.009.242l4.309,3.45V19.385h.981a3.551,3.551,0,0,0,3.635-3.456V6.219A3.547,3.547,0,0,0,23.134,2.769Z",
    transform: "translate(-2.769 -2.769)",
    fill: "#8a8a8a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComments);
export default __webpack_public_path__ + "static/media/comments.25134f34c2d1e2432d10c8cbc8651053.svg";
export { ForwardRef as ReactComponent };